import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    title: {
        id: '_.modal.phone_contact.title',
        defaultMessage: 'Give us a call'
    },
    caption: {
        id: '_.modal.phone_contact.caption',
        defaultMessage:
            'You’ll get straight through to a real person based in London. No call centres, no waiting on hold.'
    },
    availabilityMessageLineOne: {
        id: '_.modal.phone_contact.availability_message_line_one',
        defaultMessage: '8am - 7pm, Monday to Friday'
    },
    availabilityMessageLineTwo: {
        id: '_.modal.phone_contact.availability_message_line_two',
        defaultMessage: '9am - 3pm, Saturdays'
    },
    displayPhoneNumber: {
        id: '_.modal.phone_contact.display_number',
        defaultMessage: '020 3778 0105'
    },
    callPhoneNumber: {
        id: '_.modal.phone_contact.call_number',
        defaultMessage: '+44-020-3778-0105'
    }
});
